export const DEFAULT_SUPPLY_ELASTICITY = 0.4;
